/**
 * CSV export utility — converts tabular data to CSV and triggers browser download.
 */

import { recordEvent } from '../rum';

function escapeCsvValue(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function downloadCsv(filename: string, headers: string[], rows: (string | number | null | undefined)[][]): void {
  recordEvent('csv_download', { filename, rowCount: rows.length });
  const lines = [
    headers.map(escapeCsvValue).join(','),
    ...rows.map((row) =>
      row.map((cell) => escapeCsvValue(cell === null || cell === undefined ? '' : String(cell))).join(',')
    ),
  ];
  const csv = lines.join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function csvDateStamp(): string {
  return new Date().toISOString().slice(0, 10);
}
